import { getScreenWidth } from "./getScreenWidth";

/**
 * One-shot width check (SSR uses 0 width → false).
 * For itinerary/list/place shell layout, prefer `useIsDesktopLg` so behavior matches Tailwind `lg:` and updates on resize.
 */
export function isDesktop(): boolean {
  return getScreenWidth() >= 1024;
}
